import React from "react"

class SelectMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            menuOpened: false,
            selectedOption: props.input.value || {value: "-1", label: "Please select"}
        }
    }

    menuStyle = () => {
        return "choices select-menu__input  " + (this.state.menuOpened ? "is-open is-focused" : "");
    };

    menuListStyle = () => {
        return "choices__list choices__list--dropdown " + (this.state.menuOpened ? "is-active" : "")
    };

    handleClick = (e) => {
        this.setState({menuOpened: !this.state.menuOpened})
    };

    closeMenu = (e) => {
        this.setState({menuOpened: false})
    };

    handleOptionClick = (option) => {
        this.setState({selectedOption: option, menuOpened: false}, () => {
            this.props.input.onChange(option);
        });

    };

    isSelected = (value) => {
        return this.state.selectedOption.value === value
    };

    renderOptions = () => {
        let name = this.props.input.name;
        const handleOptionClick = this.handleOptionClick;
        const onBlur = this.closeMenu;
        const className = this.choiceItemClassName;
        const isSelected = this.isSelected;
        const options = this.props.options || [];
        return options.map((element, index) => {
            let id = "choices-" + name + "-item-choice-" + index + 1;
            return (
                <li key={index} className={className(element.value)}
                     data-id={index} data-value={element.value}
                     id={id} role="option"
                     aria-selected={isSelected(element.value)}
                     onClick={(e) => {
                         handleOptionClick({value: element.value, label: element.label})
                     }}

                >

                    {element.label}
                </li>
            )
        });
    };

    choiceItemClassName = (v) => {
        return "choices__item choices__item--choice choices__item--selectable " + (this.isSelected(v) ? "is-highlighted" : "")
    };

    render = () => {
        const {meta: {touched, error} } = this.props;
        const id = "choices-" + this.props.input.name + "-item-choice-1";


        return (

            <div className="widget-form__group" onMouseLeave={this.closeMenu}>
                <div className="input-wrap " >
                    <label htmlFor={this.props.input.name}>{this.props.title}</label>
                    <div id={this.props.input.name}  className={this.menuStyle()} role="listbox" data-type="select-one" tabIndex="0"
                         aria-haspopup="true" aria-expanded="false" dir="ltr" >


                        <div className="choices__inner select-menu__input__inner">

                            <select name={this.props.input.name} className="choices__input is-hidden"
                                    id={this.props.input.id} tabIndex="-1" style={{display: "none"}} aria-hidden="true"
                                    data-choice="active"
                                    onChange={this.props.input.onChange} value={this.props.input.value}>

                                <option value={this.props.input.value.value}>{this.props.input.value.label}</option>

                            </select>
                            <div className="choices__list ">
                                <div className="choices__item choices__item--selectable" onClick={this.handleClick}
                                     data-value={this.props.input.value.value || "-1"}
                                     aria-selected={this.isSelected(this.props.input.value.value || "-1")}>
                                    {this.props.input.value.label || "Please Select"}
                                </div>
                            </div>
                        </div>

                        <div className={this.menuListStyle()} aria-expanded="false" >
                            <ul className="choices__list" dir="ltr" role="listbox">
                                <li
                                    className={this.choiceItemClassName("-1")}
                                    data-id="-1"
                                    data-value="please select"
                                    id={id} role="option"
                                    aria-selected={this.isSelected("-1")}

                                >
                                    Please select
                                </li>
                                {this.renderOptions()}
                            </ul>
                        </div>
                    </div>
                    <div className="qfa1-arrow-icon__dropdown qfa1-arrow-icon" onClick={this.handleClick} style={{cursor:'pointer',height:'16px', width:'12px', position:'absolute', right:'16px' , top : '45px'}}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 6.01">
                            <title>icon-down-arrow</title>
                            <path d="M9,1.38,7.61,0,4.5,3.18,1.36,0,0,1.42,4.51,6Z" transform="translate(0.01 0.01)" style={{fill:'#323232'}}/>
                        </svg>
                    </div>
                    {touched && (error && <div className="validation-error">{error.message}</div>) }
                </div>
            </div>

        )
    }
}

export default SelectMenu;